/* tslint:disable */
export enum PaymentSchedule {
    Monthly = 0,
    Weekly = 1
}